<div class="flex flex-col lg:gap-8 gap-4 mx-auto max-w-7xl px-8 py-4 min-h-screen">
  <header class="flex items-center justify-between flex-wrap gap-4">
    <a routerLink="/" class="flex items-center gap-2 group">
      <svg aria-hidden="true" viewBox="0 0 640 512" class="w-6 h-6 fill-current text-sky-500" xmlns="http://www.w3.org/2000/svg"><path d="M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"/></svg>
      <span class="text-zinc-900 font-semibold text-lg tracking-tight">DynoLayer</span>
    </a>

    <nav class="basis-full md:basis-auto">
      <ul class="flex items-center gap-2">
        <li>
          <a
            routerLink="/docs"
            routerLinkActive="text-sky-500"
            class="flex items-center gap-1.5 p-1.5 px-3 rounded-md text-zinc-600 text-base font-medium hover:text-sky-500 hover:bg-sky-50 transition-colors"
          >
            <i class="icon-books"></i>
            <span>Documentação</span>
          </a>
        </li>
        <li>
          <a
            href="https://github.com/kauelima21/dynolayer"
            target="_blank"
            rel="noopener"
            class="flex items-center gap-1.5 p-1.5 px-3 rounded-md text-zinc-600 text-base font-medium hover:text-sky-500 hover:bg-sky-50 transition-colors"
          >
            <i class="icon-github"></i>
            <span>Código fonte</span>
          </a>
        </li>
        <li>
          <button
            type="button"
            (click)="toggleTheme()"
            [attr.aria-label]="isDark() ? 'Ativar tema claro' : 'Ativar tema escuro'"
            class="flex items-center justify-center p-2 rounded-md text-zinc-600 hover:text-sky-500 hover:bg-sky-50 transition-colors"
          >
            <i class="icon-sun"></i>
          </button>
        </li>
      </ul>
    </nav>
  </header>

  <router-outlet />

  <app-footer class="mt-auto" />
</div>
